import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  height: 30px;
  width: 30px;
  flex: none;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius};

  img {
    width: 100%;
    height: 100%;
  }
`;

export interface SharedWithProps {
  slug: string;
}

export const Avatar: React.ComponentType<SharedWithProps> = React.memo(
  ({ slug }) => {
    return (
      <Wrapper>
        <img alt={slug} src={`/images/atreides/${slug}.jpg`} />
      </Wrapper>
    );
  }
);
